<template>
  <div>
    <div class="w-100 d-inline-block bg-introduction padding-bottom-five">
      <div class="container autoContent">
        <div class="row">
          <div class="col-xl-8 col-12 col-sm-6 col-md-6 col-lg-6">
            <div class="w-100 d-inline-block margin-xl-top-5">
              <h1 class="text-black fw-bold text-full-28 family-grand-stander margin-bottom-3 text-xs-size-20">
                Professional Mobile Bird Grooming Services in Dubai
              </h1>
              <p class="text-black text-size-14 family-inter-light text-full-13 margin-bottom-3">
                Are you a feathered companion, and searching for the best bird care company in Dubai that offers bird grooming services at affordable prices? Look no further! At Dubai Pet Groomers, we specialise in providing mobile grooming services for all types of birds. Whether you have a talkative parrot, a graceful cockatoo, or a charming canary, our experienced bird groomer is dedicated to making sure your avian friends look and feel their best.
              </p>
              <p class="text-black text-size-14 family-inter-light text-full-13 margin-bottom-3">
               At Dubai Pet Groomers, we are passionate about the well-being of your avian companions. Let us help your feathered friends look and feel their best, so they can continue to brighten your life with their delightful presence! 
              </p>
            </div>
          </div>
          <div class="col-xl-4 col-12 mt-3 col-sm-6 col-md-6 col-lg-6">
            <div class="w-100 d-inline-block 
              dog-about-image">
                <img class="w-100" v-lazy="require('@/assets/images/bird-grooming-bird-grooming-services-mobile-bird-grooming.png')" alt="bird grooming, bird grooming services, mobile bird grooming">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="w-100 d-inline-block bg-gallery gallery-section">
      <div class="container autoContent">
        <div class="row margin-top-4">
          <div class="col-12">
            <div class="w-100 d-inline-block text-center margin-top-2">
              <p class="mb-0 text-size-14 text-uppercase nav-color fw-bold inter-bold-family text-full-14">
                OUR Plans
              </p>
              <h2 class="half-black fw-bold text-full-24 family-grand-stander text-uppercase text-size-24 margin-bottom-2 text-xs-size-20">
                Mobile Birds Grooming Services We Offer
              </h2>
              <p class="margin-bottom-2 text-size-14 text-black inter-regular-family d-block w-85 m-auto w-xs-100 w-sm-100 w-md-100 w-ipad-100 text-full-13">
                Grooming is a vital step in keeping your birds healthy since parasites and dust can cause diseases; thus, frequent grooming is necessary. Our customized mobile grooming services cater to your bird's specific needs, and expert pet groomers will provide you with excellent and economical bird grooming services in a comfortable or relaxed setting.  
              </p>
            </div>
          </div>
        </div>
        <div class="row margin-top-4 margin-bottom-4">
      <div class="col-12">
        <div class="w-100 d-inline-block gallery-slider about-slider position-relative">
          <div class="carousel-container">
            <transition-group class="carousel" tag="div">
              <div v-for="(plan) in planDetailPrices" :key="plan.id" class="slide">
                <div class="card w-100 d-inline-block border-0 rounded-4">
                  <!-- <img class="slide-image w-100" :src="$getImageUrl(plan.image)" :alt="plan.image" /> -->
                  <img class="slide-image w-100" v-lazy="$getImageUrl(plan.image)" :alt="plan.image">
                  <div class="card-body">
                    <h3 class="card-title text-size-14 inter-bold-family overflow-hidden margin-bottom-2 text-full-14">
                      {{ plan.name }}
                    </h3>
                    <p class="card-text text-black text-size-14 inter-regular-family overflow-hidden margin-bottom-2 text-full-13">
                      {{ plan.description }}
                    </p>
                    <a href="javascript:void(0)" class="nav-color rounded-5 text-uppercase text-size-13 d-inline-block medium-family border-blue me-xl-2 me-3 book-service-btn text-full-13"
                    @click="addToCart(plan)">
                      Book Service
                    </a>
                    <span class="text-size-16 nav-color fw-bold family-grand-stander d-inline-block mt-xl-0 mt-2 mt-lg-0 mt-md-0 text-full-16">
                      {{ plan.unit }} {{ plan.price }} 
                    </span>
                  </div>
                </div>
              </div>
            </transition-group>
            <div class="carousel-controls">
              <a href="javascript:void(0)" class="carousel-prev-btn position-absolute" @click="previous">
                <img class="position-absolute" src="@/assets/images/prev-left-icon.svg" alt="" />
              </a>
              <a href="javascript:void(0)" class="carousel-next-btn position-absolute" @click="next">
                <img class="position-absolute" src="@/assets/images/next-right-icon.svg" alt="" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
      </div>
    </div>
    <div class="w-100 d-inline-block bg-introduction">
      <div class="container autoContent">
        <div class="row mt-xl-5 mt-4">
          <div class="col-xl-6 col-12 col-sm-6 col-md-6 col-lg-6">
            <div class="w-100 d-inline-block pets-collapse margin-bottom-3 bg-white">
              <a
                class="family-filson-bold text-black text-size-14 fw-bold w-100 d-inline-block padding-top-2 text-full-14"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseExample"
                aria-expanded="false"
                aria-controls="collapseExample"
                @click="toggleCollapse"
                >
              <span class="float-start margin-right-2">
              <i class="fa fa-check-circle-o nav-color" aria-hidden="true"></i>
              </span>
              <span class="float-start w-92 text-full-14 text-size-14">
              How  frequently should you groom your bird?
              </span>
              </a>
              <div :class="['collapse', { show: isOpen }]" id="collapseExample">
                <div class="card card-body padding-top-2 p-0 border-0">
                  <p class="mb-xl-0 mb-1 text-size-14 text-black family-inter-light text-full-13">
                    Wild birds require frequent grooming because of the outside exposure, while pet birds require grooming services roughly two to three times each year.
                  </p>
                </div>
              </div>
            </div>
            <div class="w-100 d-inline-block pets-collapse margin-bottom-3 bg-white">
              <a class="family-filson-bold text-black text-size-14 fw-bold w-100 d-inline-block padding-top-2 text-full-14" type="button" data-bs-toggle="collapse" data-bs-target="#collapseExample2" aria-expanded="false" aria-controls="collapseExample">
              <span class="float-start margin-right-2">
              <i class="fa fa-check-circle-o nav-color" aria-hidden="true"></i>
              </span>
              <span class="float-start w-92 text-full-14 text-size-14">
              How much time is needed to groom a bird?
              </span>
              </a>
              <div class="collapse" id="collapseExample2">
                <div class="card card-body padding-top-2 p-0 border-0">
                  <p class="mb-xl-0 mb-1 text-size-14 text-black family-inter-light text-full-13">
                    The time required for bird grooming varies greatly depending on the service you choose and the breed of bird. Grooming a bird typically takes 30minutes to 1.5hour.
                  </p>
                </div>
              </div>
            </div>
            <div class="w-100 d-inline-block pets-collapse margin-bottom-3 bg-white">
              <a class="family-filson-bold text-black text-size-14 fw-bold w-100 d-inline-block padding-top-2 text-full-14" type="button" data-bs-toggle="collapse" data-bs-target="#collapseExample3" aria-expanded="false" aria-controls="collapseExample">
              <span class="float-start margin-right-2">
              <i class="fa fa-check-circle-o nav-color" aria-hidden="true"></i>
              </span>
              <span class="float-start w-92 text-full-14 text-size-14">
              Do birds require brushing?
              </span>
              </a>
              <div class="collapse" id="collapseExample3">
                <div class="card card-body padding-top-2 p-0 border-0">
                  <p class="mb-xl-0 mb-1 text-size-14 text-black family-inter-light text-full-13">
                    Birds, like many other pets, need to groom themselves to look their best. Brushing will make them feel better while also removing some dust and molting feathers.
                  </p>
                </div>
              </div>
            </div>
            <div class="w-100 d-inline-block pets-collapse margin-bottom-3 bg-white">
              <a class="family-filson-bold text-black text-size-14 fw-bold w-100 d-inline-block padding-top-2 text-full-14" type="button" data-bs-toggle="collapse" data-bs-target="#collapseExample4" aria-expanded="false" aria-controls="collapseExample">
              <span class="float-start margin-right-2">
              <i class="fa fa-check-circle-o nav-color" aria-hidden="true"></i>
              </span>
              <span class="float-start w-92 text-full-14 text-size-14">
              How can I safely trim my birds nails?
              </span>
              </a>
              <div class="collapse" id="collapseExample4">
                <div class="card card-body padding-top-2 p-0 border-0">
                  <p class="mb-xl-0 mb-1 text-size-14 text-black family-inter-light text-full-13">
                    To properly trim your bird nails, gently press on the paw to stretch the nail, then use bird nail clippers to cut just the tip. If your bird resists, trim only one or two nails at a time or get expert assistance.
                  </p>
                </div>
              </div>
            </div>
            <div class="w-100 d-inline-block pets-collapse margin-bottom-3 bg-white">
              <a class="family-filson-bold text-black text-size-14 fw-bold w-100 d-inline-block" type="button" data-bs-toggle="collapse" data-bs-target="#collapseExample5" aria-expanded="false" aria-controls="collapseExample">
              <span class="float-start margin-right-2">
              <i class="fa fa-check-circle-o nav-color" aria-hidden="true"></i>
              </span>
              <span class="float-start w-92 text-full-14 text-size-14">
              What are the age limitations for bird grooming services?
              </span>
              </a>
              <div class="collapse" id="collapseExample5">
                <div class="card card-body padding-top-2 p-0 border-0">
                  <p class="mb-xl-0 mb-1 text-size-14 text-black family-inter-light text-full-13">
                    It is advised that your pet receive their first grooming when they are between 4 and 8 weeks old. We take excellent care of newbies.
                  </p>
                </div>
              </div>
            </div>
            <div class="w-100 d-inline-block pets-collapse margin-bottom-3 bg-white">
              <a class="family-filson-bold text-black text-size-14 fw-bold w-100 d-inline-block padding-top-2 text-full-14" type="button" data-bs-toggle="collapse" data-bs-target="#collapseExample6" aria-expanded="false" aria-controls="collapseExample">
              <span class="float-start margin-right-2">
              <i class="fa fa-check-circle-o nav-color" aria-hidden="true"></i>
              </span>
              <span class="float-start w-92 text-full-14 text-size-14">
              How can I know whether my bird's beak needs grooming?
              </span>
              </a>
              <div class="collapse" id="collapseExample6">
                <div class="card card-body padding-top-2 p-0 border-0">
                  <p class="mb-xl-0 mb-1 text-size-14 text-black family-inter-light text-full-13">
                    A healthy beak normally maintains itself by natural activity. If you see overgrowth, cracks, it might signal a health problem, and you should seek advice from a professional groomer on proper beak care.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-6 col-12 col-sm-6 col-md-6 col-lg-6">
            <div class="w-100 d-inline-block">
              <h2 class="text-black fw-bold filson-black-family text-full-28 w-65 w-xs-100 w-sm-100 w-md-100 w-ipad-100 margin-bottom-2 text-xs-size-20">
                What makes us unique?
              </h2>
              <p class="mb-0 text-size-14 text-black family-inter-light text-full-13">
                You can always trust us to provide excellent care for your pet, as we have served thousands of clients fully satisfied with our services. Our professional Pets groomers are trained to use pet-friendly premium products and methods to provide a soothing and comfortable experience. Your furry friend's health is our top priority. Trust us, and we will make you satisfied.
              </p>
            </div>
            <div class="w-100 d-inline-block margin-top-3 about-video-image">
              <img class="w-100 rounded-4" v-lazy="require('@/assets/images/cockatiel-grooming-macaw-grooming-lovebird-grooming.png')" alt="cockatiel grooming, macaw grooming, lovebird grooming">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="w-100 d-inline-block bg-introduction">
      <div class="container autoContent">
        <div class="row margin-top-2 margin-bottom-2">
          <div class="col-12">
            <ul class="w-100 d-inline-block ps-0 bread-crumb mb-0 margin-top-1">
              <li class="float-start margin-right-2">
                <router-link class="text-black text-size-14 medium-family text-full-13" to="/"><i class="fa fa-home nav-color" aria-hidden="true"></i> Home /</router-link>
              </li>
              <li class="float-start">
                <router-link class="text-black text-size-14 medium-family text-full-13" to="/services/">Services</router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { applyServicePageSchema } from '@/utils/seo';
  import { BIRD_GROOMING_FAQS } from '@/utils/servicePageFaqs';

  export default {
    name: 'birdsGroomingBannerComponent',
      data() {
        return {
          isOpen: true,
          planDetailPrices: [], // Initialize as an empty array
        };
      },
      mounted() {
          this.fetchServiceCategories();
          this.applyStructuredData();
      },
      computed: {
        iconClass() {
          return this.isOpen ? "fa fa-check-circle-o text-green" : "fa fa-check-circle-o nav-color";
        },
      },
      methods: {
        applyStructuredData() {
          applyServicePageSchema({
            name: 'Bird Grooming Services in Dubai',
            description: this.$route.meta?.description || 'Bird grooming services in Dubai.',
            path: this.$route.path,
            offers: (this.planDetailPrices || []).map((plan) => ({
              name: plan.name || plan.title || 'Bird Grooming',
              price: plan.price,
            })),
            faqs: BIRD_GROOMING_FAQS,
          });
        },
        addToCart(service) {
        const cartData = localStorage.getItem('cart');
        let cart = cartData ? JSON.parse(cartData) : []; // Parse the cart or initialize as an empty array

        const serviceExists = cart.find((item) => item.id === service.id);

        if (serviceExists) {
          serviceExists.count++;
        } else {
          cart.push({ ...service, count: 1 });
        }
        localStorage.setItem('cart', JSON.stringify(cart));
        this.$router.push('/booking/');
      },
        async fetchServiceCategories() {
          try {
            const response = await this.$axios.post('/get-service-categories', {
              website_name: this.$websiteName,
              category_name: 'Birds Grooming',
            });
            if (response.data.status === "success") {
              this.planDetailPrices = response.data.planDetailPrices; // Assign the fetched data
              this.applyStructuredData();
            } else {
              console.error("Failed to fetch categories:", response.data);
            }
          } catch (error) {
            console.error('Error fetching categories:', error.response || error.message);
          }
        },
      previous() {
        const last = this.planDetailPrices.pop();
        this.planDetailPrices = [last].concat(this.planDetailPrices);
      },
      next() {
        const first = this.planDetailPrices.shift();
        this.planDetailPrices = this.planDetailPrices.concat(first);
      },
      toggleCollapse() {
        this.isOpen = !this.isOpen;
      },
    },
  }
</script>
<style scoped></style>